// FAQ accardion
$(".js-faq-header").on("click", function () {
  var this_btn = $(this);
  var btn_ID = $(this).attr("id");

  if ($(this_btn).hasClass("active")) {
    $(".js-faq-content").each(function () {
      var that = $(this);
      var content_ID = $(this).attr("id");
      if (content_ID == btn_ID) {
        $(that).removeClass("active");
        $(this_btn).removeClass("active");
      }
    });
  } else {
    $(".js-faq-content").each(function () {
      var that = $(this);
      var content_ID = $(this).attr("id");
      if (content_ID == btn_ID) {
        $(that).addClass("active");
        $(this_btn).addClass("active");
      }
    });
  }
});

$(".js-faq-search-result ul").on(
  "click",
  ".faq-search-result__link",
  function (e) {
    e.preventDefault();

    var that = this,
      that_ID = $(that).data("id");

    $(".js-faq-search-input").val($(that).text());
    $(".js-faq-search-result").hide();
    $(".js-faq-search-result ul").empty();

    $(".js-faq-header").each(function () {
      var answer_this = this,
        answer_ID = $(answer_this).attr("id");

      if (that_ID == answer_ID) {
        $(answer_this).addClass("active");
        $(answer_this).parents(".js-faq-content").addClass("active");
        $(answer_this).parents(".js-faq-content").prev().addClass("active");

        $("html, body").animate(
          {
            scrollTop: $(answer_this).offset().top - 150,
          },
          2000
        );
      }
    });

    $(".js-faq-content").each(function () {
      var answer_this = this,
        answer_ID = $(answer_this).attr("id");

      if (that_ID == answer_ID) {
        $(answer_this).addClass("active");
      }
    });
  }
);

if ($(".js-faq-search").length) {
  var jsonObj = [];

  $(".js-faq-header").each(function () {
    var q_id = $(this).attr("id"),
      q_text = $(this).find("h4").text();

    item = {};
    item["id"] = q_id;
    item["question"] = q_text;

    jsonObj.push(item);
  });

  $(".js-faq-search-input").on("input", function () {
    var search_text = this.value.toLowerCase();
    var search_result = "";

    if (this.value != "") {
      $.each(jsonObj, function (i, v) {
        if (v.question.toLowerCase().includes(search_text) == true) {
          $(".js-faq-search-result").show();
          search_result +=
            '<li class="faq-search-result__link" data-id="' +
            v.id +
            '" >' +
            v.question +
            "</li>";
        } else {
          console.log(12444);
          //console.log(search_text)
          //$('.js-faq-search-result').show()
        }
      });
    } else {
      $(".js-faq-search-result").hide();
      search_result = "";
    }

    $(".js-faq-search-result ul").html(search_result);
  });
}

$(document).on("click", function () {
  $(".js-faq-search-result").hide();
});

$(document).ready(function () {
  // Function to handle smooth scrolling with offset
  const smoothScroll = (target) => {
    $("html, body").animate(
      {
        scrollTop: $(target).offset().top - 80,
      },
      300
    );
  };

  // Smooth scroll on click
  $('a[href^="#"]').on("click", function (event) {
    const hash = window.location.hash;
    if ($(this).hasClass("not_prevent") || $(this).hash === undefined) {
      return 0;
    }
    event.preventDefault();
    const target = $(this).attr("href");
    if (target != "#") {
      smoothScroll(target);
    }
  });

  // Check if there's a hash in the URL on page load
  const hash = window.location.hash;
  if (hash) {
    smoothScroll(hash);
  }
});
$(document).ready(function () {
  var hash = window.location.hash;
  if(hash != ''){
    that_ID = hash.replace('#','');
    $(".js-faq-header").each(function () {
      var answer_this = this,
        answer_ID = $(answer_this).attr("id");

      if (that_ID == answer_ID) {
        $(answer_this).addClass("active");
        $(answer_this).parents(".js-faq-content").addClass("active");
        $(answer_this).parents(".js-faq-content").prev().addClass("active");

        $("html, body").animate(
          {
            scrollTop: $(answer_this).offset().top - 150,
          },
          2000
        );
      }
    });

    $(".js-faq-content").each(function () {
      var answer_this = this,
        answer_ID = $(answer_this).attr("id");

      if (that_ID == answer_ID) {
        $(answer_this).addClass("active");
      }
    });
  }
  $('a[href^="/pages/faq/#"]').on("click", function (e) {
    e.preventDefault();
    var target = this.hash;
    if(target != ''){
      that_ID = target.replace('#','');
      $(".js-faq-header").each(function () {
        var answer_this = this,
          answer_ID = $(answer_this).attr("id");
  
        if (that_ID == answer_ID) {
          $(answer_this).addClass("active");
          $(answer_this).parents(".js-faq-content").addClass("active");
          $(answer_this).parents(".js-faq-content").prev().addClass("active");
  
          $("html, body").animate(
            {
              scrollTop: $(answer_this).offset().top - 150,
            },
            2000
          );
        }
      });
  
      $(".js-faq-content").each(function () {
        var answer_this = this,
          answer_ID = $(answer_this).attr("id");
  
        if (that_ID == answer_ID) {
          $(answer_this).addClass("active");
        }
      });
    }
  });
});
